import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Button
} from '@material-ui/core';
import { setQuoteMarketingSegmentData } from 'redux/actions/quote';
import { showNotification } from 'redux/actions/ui';


const SelectGroupButton = ({group, handleCloseModal, isDisabled}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    options
  } = useSelector((state: IReduxState) => state.eavAttributes);

  const handleSelectGroup = async () => {
    if (!options.length) {
      dispatch(showNotification(
        'warning',
        'Please configure Marketing Segments'
      ));
    } else {
      dispatch(setQuoteMarketingSegmentData(group));
      history.push(`/quoting/group/${group.value}`);
      handleCloseModal();
    }
  };

  return (
    <Button
      color="primary"
      variant="contained"
      className="uppercase text-12 mr-2 whitespace-no-wrap px-2"
      onClick={handleSelectGroup}
      disabled={isDisabled}
    >
      Select
    </Button>
  );
};

export default SelectGroupButton;
